export const translateFolderId = '3752c3cb-914d-472b-a7dd-5786cee48767';